export { default } from './ShoppingCartIcon';
